export const splitUnderscoreAndCapitalize = (input: string): string => {
  const parts = input.split('_')

  if (parts.length < 2) {
    return input.charAt(0).toUpperCase() + input.slice(1)
  }

  const first = parts[0].charAt(0).toUpperCase() + parts[0].slice(1)
  const second = parts[1].charAt(0).toUpperCase() + parts[1].slice(1)

  return `${first} ${second}`
}
